
import { CATEGORY_GENERAL2_NAME_LIST } from 'lib/const';
import { Bar } from 'react-chartjs-2';

export const CategoryGeneral2 = ({userReport=null}) => {
  
  if(!userReport)return null;
  let values = new Array(12).fill(0);
  
  userReport.books.forEach((item)=>{
    values[item.categoryGeneral2] += 1;
  });
  
  
  let labels = new Array(12).fill("").map((_, idx) => `${CATEGORY_GENERAL2_NAME_LIST[idx]}: ${values[idx]}`);
  
  
  const data = {
    labels: labels,
    datasets: [{
      data: values,
      backgroundColor: [ '#ede264', '#DFFF00', '#FFBF00', '#FF7F50', '#DE3163',  '#9FE2BF',
      '#71ed64', '#40E0D0', '#fff600',  '#6495ED', '#9b64ed',  '#CCCCFF' ],
      hoverBackgroundColor: [ '#ede264', '#DFFF00', '#FFBF00', '#FF7F50', '#DE3163',  '#9FE2BF',
      '#71ed64', '#40E0D0', '#fff600',  '#6495ED', '#9b64ed',  '#CCCCFF' ]
    }]
  };
  

  return (
      <Bar width={800}  height={120}
          options={{
              responsive:true,
              maintainAspectRatio:true,
              plugins:{ legend:false },
              scales: {
                  y:{
                      stacked: true,
                      ticks: { precision: 0, stepSize:50}
                  }
              }
          }}
      data={data}
      legend={{display:false}}
       />
  );

};